import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  DSButton,
  ErrorMessage,
  InputLabel,
  SelectOption
} from "components/UI/atoms";
import { useBrandAlertContext } from "context/brand-alert-context";
import { validationSchema } from "./utils/validationSchema";
import { FORM_DEFAULT_VALUES, FREQUENCY_OPTIONS } from "./utils/constants";
import "./index.scss";

export const BrandAlertModalForm = ({
  initialValues,
  brandName,
  onSaveBrandAlert,
  handleCancelAlert
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    trigger,
    watch
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: FORM_DEFAULT_VALUES,
    values: initialValues
  });
  const { productSourceId } = useBrandAlertContext();

  const minimumDiscountValue = watch("minimumDiscount");
  const saveBrandAlert = (values) => {
    if (isValid) onSaveBrandAlert({ formValues: values, productSourceId });
  };
  const currentError =
    errors.minimumValue || errors.maximumValue || errors.frequency || "";

  return (
    <div
      className="brand-alert-modal-form"
      data-testid="brand-alert-modal-form"
    >
      <p className="modal-form-title">
        Email me when {brandName || ""} gift cards become available.
      </p>
      <form onSubmit={handleSubmit(saveBrandAlert)} className="modal-form">
        <div className="form-first-line">
          <div className="field-container">
            <InputLabel
              placeholder="5"
              label="Min Card Value"
              id="minimumValue"
              name="minimumValue"
              hasError={errors.minimumValue}
              type="number"
              customClassname="modal-form-input"
              {...register("minimumValue")}
              preIcon={<span className="pre-icon">$</span>}
              onBlur={(e) => {
                register("minimumValue").onBlur(e);
                trigger("minimumValue");
              }}
            />
          </div>
          <div className="field-container">
            <InputLabel
              placeholder="2000"
              label="Max Card Value"
              id="maximumValue"
              name="maximumValue"
              hasError={errors.maximumValue}
              type="number"
              customClassname="modal-form-input"
              {...register("maximumValue")}
              preIcon={<span className="pre-icon">$</span>}
              onBlur={(e) => {
                register("maximumValue").onBlur(e);
                trigger("maximumValue");
                trigger("minimumValue");
              }}
            />
          </div>
          <div className="form-errors-line only-mobile">
            {!!currentError && (
              <ErrorMessage
                error={errors.minimumValue || errors.maximumValue}
              />
            )}
          </div>
          <div className="select-container">
            <SelectOption
              options={[
                { value: null, label: "Set Frequency" },
                ...FREQUENCY_OPTIONS
              ]}
              id="frequency"
              name="frequency"
              hasError={errors.frequency}
              {...register("frequency")}
              onBlur={(e) => {
                register("frequency").onBlur(e);
                trigger("frequency");
              }}
            />
            <div className="form-errors-line only-mobile">
              {!!currentError && <ErrorMessage error={errors.frequency} />}
            </div>
          </div>
        </div>
        <div className="form-errors-line only-desktop">
          {!!currentError && <ErrorMessage error={currentError} />}
        </div>

        <div className="form-second-line">
          <div className="field-ranger-container">
            <InputLabel
              placeholder="5"
              label="How much would you like to save?"
              id="minimumDiscount"
              name="minimumDiscount"
              hasError={errors.minimumDiscount}
              type="range"
              customClassname="modal-form-input-range"
              {...register("minimumDiscount")}
              min={0}
              max={25}
              step={1}
            />
            <p className="minimum-value">Minimum: {minimumDiscountValue}%+</p>
          </div>
        </div>

        <div className="buttons-area">
          <DSButton
            variant="outlined"
            type="button"
            disabled={!initialValues}
            onClick={handleCancelAlert}
          >
            Cancel Alert
          </DSButton>
          <DSButton variant="secondary" disabled={!isValid} type="submit">
            Set Alert
          </DSButton>
        </div>
      </form>
    </div>
  );
};
